import React from 'react';

const AdSense = ({ client, slot }) => {
  // Show placeholder in development
  if (process.env.NODE_ENV === 'development') {
    return (
      <div 
        className="ad-placeholder"
        style={{
          background: 'rgba(0, 0, 0, 0.2)',
          border: '1px dashed rgba(255, 255, 255, 0.2)',
          borderRadius: '8px',
          padding: '1rem',
          margin: '1rem 0',
          textAlign: 'center',
          color: 'rgba(255, 255, 255, 0.6)',
          fontSize: '0.9rem'
        }}
      >
        Advertisement Placeholder
        <br />
        <small>(Only visible in development)</small>
      </div>
    );
  }

  // Real ad in production
  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default AdSense; 